import {
  PROCESSING_SUBMIT,
  SUBMIT_COMPLETED,
  SUBMIT_PRACTICE_INFO_COMPLETED
} from '../actions';

import {
  SET_PREVIOUS_ROUTE,
  UPDATE_PROGRESS_BAR
} from '../actions/onboarding';

import {
  SUBMIT_OWNERSHIP
} from '../actions/ownership';

import {
  SUBMIT_MANAGEMENT_INFO_COMPLETE
} from '../actions/significantController';


const defaultState = {
  percentage: 0,
  previousRoute: '',
  hasCompletedReview: false,
  enrollmentComplete: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SUBMIT_OWNERSHIP:
      return { ...state,
        previousRoute: action.previousRoute,
        ownerships_submitted: true
      };
    case SUBMIT_PRACTICE_INFO_COMPLETED:
    case SUBMIT_MANAGEMENT_INFO_COMPLETE:
    case UPDATE_PROGRESS_BAR: {
      const { onboarding } = action.payload;
      return { ...state, ...onboarding };
    }
    case SET_PREVIOUS_ROUTE:
      return { ...state, previousRoute: action.previousRoute };
    case PROCESSING_SUBMIT:
        return { ...state, processingSubmit: true };
    case SUBMIT_COMPLETED:
      return { ...state, processingSubmit: false };
    default:
      return state;
  }
};

